const moduleName = "underConstructionModule";

const state = {
    title: "Fitur Dalam Perbaikan",
    subtitle: "Maafkan kami atas ketidaknyamanan yang terjadi. Kami akan segera kembali",
};
export { state as default, moduleName };
